import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { AuthService } from '@personal-area/global/authorization/services';

/**
 * Редиректит на страницу login, если пользователь не авторизован.
 */
@Injectable({ providedIn: 'root' })
export class LogoutGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (this._authService.isLoggedIn) {
      this._authService.logout(false);
    }

    return this._router.createUrlTree(['/login'], {
      queryParams: route.queryParams
    });
  }
}
